import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { UserLoginModel } from '../models/user.model';
import { MfaVerifyComponent } from '../components/shared/dialogs/mfa-verify/mfa-verify.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private url = environment.API_URL;

  userToken: string = "";

  private http: HttpClient;

  constructor(
    handler: HttpBackend,
    private matDialog: MatDialog,
  ) {
    this.http = new HttpClient(handler);
    this.readToken();
  }

  logout() {
    this.userToken = '';
    localStorage.removeItem('token');
    localStorage.removeItem('expires');
  }

  loginPasswordReset(rp: string) {
    return this.http.post<{ message: string; tkn: string; exp: number; mfa: number }>(
      `${this.url}/users/loginPasswordReset`, { rp }
    ).pipe(map(response => {
      if (response.message !== 'Success' || !response.tkn) {
        throw new Error('Unable to complete password reset login');
      }
      this.saveToken(response.tkn);
      return response;
    }));
  }

  login( user: UserLoginModel ) {
    const authData = {
      ...user
    };
    return this.http.post(
      `${ this.url }/users/login`,
      authData
    ).pipe(
      map(async (resp : any) => {
        if(resp.mfa == 1){
                this.matDialog.open(MfaVerifyComponent, {
                  panelClass: ['dialogs-sm'],
                  data: authData,
                  disableClose: true,
                  autoFocus: "dialog"
                }).afterClosed().subscribe(
                  result => {
                    //if (resp.reload) 
                    return false;
                  }
                );
        }else{
           this.saveToken( resp['tkn'] );
           return resp;
        }

      })
    );
  }

  resendCode(user : any){
    return this.http.post(
      `${ this.url }/users/login`,
      user
    ).pipe( map(async (resp : any) => { return resp;}));
  }

  saveToken( idToken: string ) {
    this.userToken = idToken;
    localStorage.setItem('token', idToken);

    let hoy = new Date();
    hoy.setSeconds( 64800 );

    localStorage.setItem('expires', hoy.getTime().toString() );
  }

  readToken() {
    if ( localStorage.getItem('token') ) {
      this.userToken = localStorage.getItem('token')!;
    } else {
      this.userToken = '';
    }
    return this.userToken;
  }

  isAuthenticated(): boolean {
    if ( this.userToken.length < 2 ) {
      return false;
    }
    const expire = Number(localStorage.getItem('expires'));
    const expireDate = new Date();
    expireDate.setTime(expire);

    if ( expireDate > new Date() ) {
      return true;
    } else {
      return false;
    }
  }

}
